function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoNFTCardTemplate = require('./saito-nft-card.template');
var SaitoNFT = require('./saito-nft');
var SaitoNFTCard = /*#__PURE__*/function () {
  function SaitoNFTCard(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var tx = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var data = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var callback = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
    _classCallCheck(this, SaitoNFTCard);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.nft = new SaitoNFT(app, mod, tx, data);
    this.template = SaitoNFTCardTemplate;
    this.my_qs = this.container + " #nft-card-".concat(this.nft.uuid);

    //
    // UI helpers
    //
    this.callback = callback;
    this.expires_timer = null;
  }
  return _createClass(SaitoNFTCard, [{
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this$app,
          _this = this;
        var this_self, _this$nft;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this_self = this;
              this.stopExpiresTimer();
              if ((_this$app = this.app) !== null && _this$app !== void 0 && (_this$app = _this$app.browser) !== null && _this$app !== void 0 && _this$app.addStylesheet) {
                this.app.browser.addStylesheet('/saito/css-imports/ui/saito-nft.css');
              }
              if (document.querySelector(this.container)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              if (this.nft.slip2) {
                _context.n = 2;
                break;
              }
              _context.n = 2;
              return this.nft.fetchTransaction();
            case 2:
              //
              // render can be writing a NEW NFT Card or attempting to re-render
              // an existing one.
              //

              if (document.querySelector(this.my_qs)) {
                this.app.browser.replaceElementBySelector(this.template(this.app, this.mod, this.nft), this.my_qs);
              } else {
                this.app.browser.prependElementToSelector(this.template(this.app, this.mod, this.nft), this.container);
              }

              //
              // avoid re-fetching of nft tx
              //
              if (!this.nft.tx_fetched) {
                this.nft.fetchTransaction(function () {
                  this_self.insertNFTDetails();
                });
              } else {
                if ((_this$nft = this.nft) !== null && _this$nft !== void 0 && _this$nft.tx) {
                  this.insertNFTDetails();
                } else {
                  console.warn('NFT-Card: No transaction..., cannot insert details...');
                }
              }

              // Ensure DOM is in place
              setTimeout(function () {
                return _this.attachEvents();
              }, 0);
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "attachEvents",
    value: function () {
      var _attachEvents = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this2 = this;
        var el;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              el = document.querySelector(this.my_qs);
              if (el) {
                el.onclick = function () {
                  if (_this2.callback) {
                    _this2.callback(_this2.nft);
                  } else {
                    _this2.app.connection.emit('saito-nft-details-render-request', _this2.nft);
                  }
                };
              }
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function attachEvents() {
        return _attachEvents.apply(this, arguments);
      }
      return attachEvents;
    }()
  }, {
    key: "insertNFTDetails",
    value: function insertNFTDetails() {
      if (!this.app.BROWSER) {
        return 0;
      }
      console.log('Insert fetched NFT details into CARD');
      var type = document.querySelector(this.my_qs + ' .saito-nft-card-type');
      if (type) {
        type.textContent = this.nft.returnType() || '';
      }
      if (this.nft.title) {
        try {
          var telm = document.querySelector(this.my_qs + ' .saito-nft-card-title');
          telm.textContent = this.nft.title;
        } catch (err) {}
      }
      var elm = document.querySelector(this.my_qs + ' .saito-nft-card-img');
      if (elm) {
        var display = this.nft.returnMediaDisplay();
        if (display.loading) {
          elm.innerHTML = "<div class=\"saito-spinner spinner\"></div>";
          elm.style.backgroundImage = '';
          return;
        }
        elm.innerHTML = display.innerHtml || '';
        if (this.app.browser.isSafeMediaUrl(display.backgroundImage)) {
          elm.style.backgroundImage = "url(\"".concat(String(display.backgroundImage).replace(/"/g, '%22'), "\")");
        } else {
          elm.style.backgroundImage = '';
        }
        this.startExpiresTimer();
      } else {
        console.warn('NFT Element not rendered --', this.my_qs);
      }
    }
  }, {
    key: "stopExpiresTimer",
    value: function stopExpiresTimer() {
      if (this.expires_timer) {
        clearInterval(this.expires_timer);
        this.expires_timer = null;
      }
    }
  }, {
    key: "startExpiresTimer",
    value: function startExpiresTimer() {
      var _this3 = this;
      this.stopExpiresTimer();
      if (this.nft.expires_at == null || this.nft.expires_at === '') {
        return;
      }
      this.tickExpiresClock();
      this.expires_timer = setInterval(function () {
        if (!document.querySelector(_this3.my_qs)) {
          _this3.stopExpiresTimer();
          return;
        }
        _this3.tickExpiresClock();
      }, 1000);
    }
  }, {
    key: "tickExpiresClock",
    value: function tickExpiresClock() {
      var img = document.querySelector(this.my_qs + ' .saito-nft-card-img');
      if (!img) {
        this.stopExpiresTimer();
        return;
      }
      var clock = img.querySelector('.saito-nft-expires-clock');
      if (!clock) {
        clock = document.createElement('div');
        clock.className = 'saito-nft-expires-clock';
        img.appendChild(clock);
      }
      clock.textContent = this.nft.remainingExpiresLabel();
    }
  }]);
}();
module.exports = SaitoNFTCard;